export default __webpack_public_path__ + "search-examples-search-ui-and-maps-sdk-960-4aa1aad29b1e1559abfed9b8b4450efc.webp";